<template>
    <div>
        <MenuPos/>
    </div>
</template>

<script>
    import MenuPos from "@/components/admin/manage_pos/menu_pos/MenuPos.vue";
    export default {
        name: "ManageMainPos",
        components: {
            MenuPos,
        }
    }
</script>

<style scoped>

</style>
